import { ChangeEventHandler, FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { FileUpload } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Button, Grid } from '@mui/material'

type EventScreenshotsUploaderProps = {
  files: File[]
  onChange: ChangeEventHandler<HTMLInputElement>
  onUpload: () => void
  isUploading?: boolean
}
export const EventScreenshotsUploader: FC<EventScreenshotsUploaderProps> = ({ files, onChange, onUpload, isUploading }) => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  // A native button, so Enter and Space open the picker too. Cleared first so picking the same file again still fires `change`.
  const openPicker = () => {
    if (!inputRef.current) return
    inputRef.current.value = ''
    inputRef.current.click()
  }
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <Button variant="contained" color="primary" onClick={openPicker}>
          {t('internal-common:select_files')}
        </Button>
        <input ref={inputRef} type="file" multiple accept="image/*" hidden tabIndex={-1} onChange={onChange} />
      </Grid>
      <Grid item>
        <LoadingButton
          onClick={onUpload}
          loading={isUploading}
          variant="contained"
          color="success"
          loadingPosition="start"
          startIcon={<FileUpload />}
          disabled={!files || files.length === 0}
        >
          {t('internal-common:start_upload')}
        </LoadingButton>
      </Grid>
    </Grid>
  )
}
